import React from "react";
import Layout from "../../Layout";
import CoachAI from "../../CoachAI";

export default function CoachAIPage() {
  return (
    <Layout>
      <CoachAI />
    </Layout>
  );
}
